import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=7c0c8b84&scoped=true"
import script from "./ProcessDesign.vue?vue&type=script&lang=js"
export * from "./ProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=7c0c8b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c8b84",
  null
  
)

export default component.exports